import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const axisCareReportListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item.id}</>,
    },
    {
      text: "First Name",
      dataField: "first_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{item?.first_name ? item?.first_name : "-"}</>
      ),
    },
    {
      text: "Last Name",
      dataField: "last_name",
      formatter: (cellContent, item) => (
        <>
          <>{item?.last_name ? item?.last_name : "-"}</>
        </>
      ),
    },
    {
      text: "Email Address",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.email || "-"}</>,
    },
    {
      text: "Display Name",
      dataField: "display_name",
      formatter: (cellContent, item) => (
        <>
          <>{item?.display_name ? item?.display_name : "-"}</>
        </>
      ),
    },
    {
      text: "Birth Date",
      dataField: "birth_date",
      formatter: (cellContent, item) => (
        <>
          <>{item?.birth_date ? item?.birth_date : "-"}</>
        </>
      ),
    },
    {
      text: "Hire Date",
      dataField: "hire_date",
      formatter: (cellContent, item) => (
        <>
          <>{item?.hire_date ? item?.hire_date : "-"}</>
        </>
      ),
    },
    {
      text: "Axiscare ID",
      dataField: "axis_care_id",
      formatter: (cellContent, item) => (
        <>{item?.axis_care_id ? item?.axis_care_id : "-"}</>
      ),
    },
    {
      text: "Import Error",
      dataField: "import_error",
      formatter: (cellContent, item) => (
        <>{item?.import_error ? item?.import_error : "-"}</>
      ),
    },
    {
      text: "Import Date",
      dataField: "import_date",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>{item?.import_date ? item?.import_date : "-"}</>
      ),
    },
  ]
}

export default axisCareReportListColumns
